// Authenticated API client for the marketing engine.
// Uses the host app's apiConfig.js for URL resolution and cookie-based auth.
import axios from "axios";
import { API } from "../apiConfig";

export const MARKETING_API_BASE = `${API}/marketing`;

const marketingApi = axios.create({
  baseURL: MARKETING_API_BASE,
  withCredentials: true,
});

export default marketingApi;
